module.exports = __webpack_public_path__ + "img/circle-graph-icon-21022022.b81f15f2.svg";